import { Swiper } from 'swiper';
import 'swiper/css';

export default function textItems() {
    if (document.querySelector('.faq__swiper')) {
        initSwiper();
    }
}

const initSwiper = () => {
    return new Swiper('.faq__swiper', {
        slidesPerView: 1.2,
        spaceBetween: 16,
        enabled: true,
        breakpoints: {
            640: {
                enabled: true,
                slidesPerView: 1.8,
                spaceBetween: 16,
            },
            1024: {
                enabled: false,
                slidesPerView: 2,
                spaceBetween: 16,
                enabled: false,
            },
        },
    });
};
